(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const lerp = (a, b, t) => a + (b - a) * t;

  // reveal / chars / mask
  document.querySelectorAll('.cccp-chars').forEach((el) => {
    const text = el.textContent;
    el.textContent = '';
    const sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = text;
    el.appendChild(sr);
    let i = 0;
    text.trim().split(/\s+/).forEach((word, w) => {
      if (w) el.append(' ');
      const wordEl = document.createElement('span');
      wordEl.className = 'cccp-word';
      wordEl.setAttribute('aria-hidden', 'true');
      [...word].forEach((ch) => {
        const s = document.createElement('span');
        s.className = 'cccp-char';
        s.style.setProperty('--i', i++);
        s.textContent = ch;
        wordEl.appendChild(s);
      });
      el.appendChild(wordEl);
    });
  });

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.25 });
  document.querySelectorAll('.cccp-reveal, .cccp-chars, .cccp-mask').forEach((el) => io.observe(el));

  // editor re-render: show at once
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.cccp-reveal, .cccp-chars, .cccp-mask').forEach((el) => el.classList.add('is-in'));
    e.target.querySelectorAll('.cccp-seal').forEach((el) => el.classList.add('is-pressed'));
  });

  // side cart overlay: click outside closes, no auto-reopen on next page
  const pageWrapper = document.querySelector('.page-wrapper');
  pageWrapper?.addEventListener('click', (e) => {
    if (e.target !== pageWrapper || !pageWrapper.classList.contains('page-wrapper--drawer-open')) return;
    document.querySelectorAll('theme-drawer[open]').forEach((d) => d.close?.());
  });
  window.addEventListener('pagehide', () => {
    try { sessionStorage.removeItem('theme-drawer-open'); } catch (err) { /* storage blocked */ }
  });

  // split media: light follows the cursor
  if (!reduced && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.cccp-split__media--aura').forEach((media) => {
      const frame = media.querySelector('.cccp-split__frame');
      if (!frame) return;
      let raf = 0;
      media.addEventListener('pointermove', (e) => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const r = frame.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width;
          const y = (e.clientY - r.top) / r.height;
          frame.style.setProperty('--cccp-mx', `${(x * 100).toFixed(1)}%`);
          frame.style.setProperty('--cccp-my', `${(y * 100).toFixed(1)}%`);
        });
      });
      media.addEventListener('pointerleave', () => cancelAnimationFrame(raf));
    });
  }

  // seal press, data-cccp-seal-after = text selector
  document.querySelectorAll('.cccp-seal').forEach((seal) => {
    const target = document.querySelector(seal.dataset.cccpSealAfter) || seal;
    const sealIo = new IntersectionObserver(([e]) => {
      if (e.isIntersecting && e.intersectionRatio > 0.9) {
        setTimeout(() => seal.classList.add('is-pressed'), 300);
        sealIo.disconnect();
      }
    }, { threshold: [0.9] });
    sealIo.observe(target);
  });

  // header overlay (unused)
  if (document.body.classList.contains('cccp-header-overlay')) {
    const onScroll = () => document.body.classList.toggle('is-scrolled', window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // hero parallax: data-depth-x/y px, data-scroll factor
  const hero = document.querySelector('.cccp-hero');
  if (hero && !reduced) {
    const layers = [...hero.querySelectorAll('.cccp-hero__layer')].map((el) => ({
      el,
      dx: parseFloat(el.dataset.depthX || 0),
      dy: parseFloat(el.dataset.depthY || 0),
      sc: parseFloat(el.dataset.scroll || 0),
      x: 0, y: 0,
    }));
    let px = 0, py = 0;
    let inView = true;

    const finePointer = window.matchMedia('(pointer: fine)').matches;
    if (finePointer) {
      hero.addEventListener('pointermove', (e) => {
        const r = hero.getBoundingClientRect();
        px = ((e.clientX - r.left) / r.width) * 2 - 1;
        py = ((e.clientY - r.top) / r.height) * 2 - 1;
      });
      hero.addEventListener('pointerleave', () => { px = 0; py = 0; });
    } else if ('DeviceOrientationEvent' in window && typeof DeviceOrientationEvent.requestPermission !== 'function') {

      window.addEventListener('deviceorientation', (e) => {
        px = Math.max(-1, Math.min(1, (e.gamma || 0) / 30));
        py = Math.max(-1, Math.min(1, ((e.beta || 0) - 45) / 30));
      });
    }
    const scrollDriven = !finePointer;

    new IntersectionObserver(([e]) => { inView = e.isIntersecting; }).observe(hero);

    const tick = () => {
      if (inView) {
        const s = Math.max(0, -hero.getBoundingClientRect().top); // Horizon scrolls .page-wrapper, not window
        const progress = Math.min(1, s / hero.offsetHeight);
        layers.forEach((l) => {
          const tx = l.dx * (scrollDriven ? progress : px);
          const ty = l.dy * (scrollDriven ? progress : py) + s * l.sc;
          l.x = lerp(l.x, tx, 0.08);
          l.y = lerp(l.y, ty, 0.08);
          l.el.style.transform = `translate3d(${l.x.toFixed(2)}px, ${l.y.toFixed(2)}px, 0)`;
        });
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  // carousel progress: data-cccp-track / data-cccp-bar
  document.querySelectorAll('[data-cccp-track]').forEach((track) => {
    const bar = document.querySelector(`[data-cccp-bar="${track.dataset.cccpTrack}"]`);
    if (!bar) return;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const visible = track.clientWidth / track.scrollWidth;
      const pct = max > 0 ? visible + (1 - visible) * (track.scrollLeft / max) : 1;
      bar.style.width = `${(pct * 100).toFixed(2)}%`;
    };
    update();
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  });

  // load more: data-cccp-grid / data-cccp-more
  document.querySelectorAll('[data-cccp-more]').forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const url = btn.getAttribute('href');
      if (!url) return;
      btn.setAttribute('aria-busy', 'true');
      const html = await fetch(url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = document.querySelector('[data-cccp-grid]');
      doc.querySelectorAll('[data-cccp-grid] > *').forEach((card) => grid.appendChild(card));
      const next = doc.querySelector('[data-cccp-more]');
      if (next) { btn.setAttribute('href', next.getAttribute('href')); btn.removeAttribute('aria-busy'); }
      else btn.remove();
      history.replaceState(null, '', url);
    });
  });

  // dialogs: data-cccp-open="x" opens #cccp-dialog-x
  document.querySelectorAll('[data-cccp-open]').forEach((btn) => {
    const dlg = document.getElementById(`cccp-dialog-${btn.dataset.cccpOpen}`);
    if (!dlg) return;
    btn.addEventListener('click', () => dlg.showModal());
    dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-cccp-close]')) dlg.close(); });
  });
})();
